module.exports = __webpack_public_path__ + "static/media/MC.6d794a78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/MC.svg
// module id = 247
// module chunks = 0